import React from 'react';
import SEO from '../components/ui/SEO';
import Button from '../components/ui/Button';
import { Mail, Clock, MapPin } from 'lucide-react';
import { callsToAction, practiceEmail, turnaround } from '../data/practice';
const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Instruct Dr Syed',
  description: 'Send a case type, jurisdiction and deadline to instruct an independent psychiatric expert witness for proceedings in England and Wales.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Medicolegal Psychiatry',
    url: 'https://medicolegal-psychiatry.co.uk',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'instructions and enquiries',
      email: 'enquiries@medicolegal-psychiatry.co.uk',
      availableLanguage: ['English', 'Urdu', 'Hindi', 'Punjabi'],
      areaServed: ['England', 'Wales']
    },
    openingHoursSpecification: [{
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '17:00'
    }, {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '09:00',
      closes: '13:00'
    }]
  }
};
export default function Contact() {
  return <main className="min-h-screen bg-white" data-id="element-550" data-mp="1j73fpysvuvn3">
      <SEO title="Instruct Dr Syed | Medicolegal Psychiatry" description="Instruct an independent psychiatric expert witness for proceedings in England and Wales. Send your case type, jurisdiction and deadline." path="/contact" keywords={['instruct a psychiatric expert witness', 'psychiatric expert witness enquiry', 'medico-legal psychiatry contact']} imageAlt="Instruct Dr Imtiaz Syed, Independent Psychiatric Expert Witness" schema={contactSchema} data-id="element-551" data-mp="1j8xzh9sf4hpl" />
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-552" data-mp="2btxwakmkxava">
        <div className="container mx-auto px-4" data-id="element-553" data-mp="1m6kccxy1fs7s">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-554" data-mp="1m9gaam9vygw8">
            Contact Medico-Legal Psychiatry
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-555" data-mp="1w4hztj82pkzc">
            Get in Touch for Expert Psychiatric Assessments
          </p>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-556" data-mp="13g2qndbmhwvx">
        <div className="container mx-auto px-4" data-id="element-557" data-mp="13h5etdhk9l85">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-558" data-mp="yiavmafoluni">
            <p className="text-slate-dark text-lg mb-6" data-id="element-559" data-mp="yjlxg4pkgsbz">
              We've made it easy for you to reach us. Choose the method that
              works best for you:
            </p>
            <ul className="space-y-6 mb-8" data-id="element-560" data-mp="18edyxjm9rzc1">
              <li className="flex items-start" data-id="element-561" data-mp="kqe52atnvst8">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-562" data-mp="kp32gebycr3p">
                  <Mail className="h-6 w-6" data-id="element-563" data-mp="fs2v803d9ib0" />
                </div>
                <div data-id="element-564" data-mp="2remzg55e06tj">
                  {/* h2, not h3: these contact methods are the first headings
                      after the page H1. Classes unchanged. */}
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-565" data-mp="2w6o7tfzfpdea">
                    Direct Email
                  </h2>
                  <p className="text-slate-dark mb-2" data-id="element-566" data-mp="2mfac7jalsxqf">
                    For initial enquiries and fee quotes, email a short outline
                    of the case. Please do not send medical records or
                    instruction bundles until Dr Syed has confirmed the
                    instruction and agreed how documents will be shared.
                  </p>
                  <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-primary hover:text-secondary transition-colors" data-id="element-567" data-mp="316iwrdznfswp">
                    enquiries@medicolegal-psychiatry.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-568" data-mp="29y0we7mebfq7">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-569" data-mp="29ysrlhc2zbfy">
                  <Clock className="h-6 w-6" data-id="element-570" data-mp="2570x4vpt0lkj" />
                </div>
                <div data-id="element-571" data-mp="2087ll8u2v4n0">
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-572" data-mp="207oaaayxnehy">
                    Our Hours
                  </h2>
                  <p className="text-slate-dark mb-2" data-id="element-573" data-mp="1vapn6cdos7t9">
                    Our team is available to process your messages and
                    coordinate discussions during:
                  </p>
                  <ul className="space-y-1 text-slate-dark" data-id="element-574" data-mp="2nybmh8fvsqab">
                    <li data-id="element-575" data-mp="2iy60o8waly05">
                      Monday to Friday: 9:00 AM to 5:00 PM (GMT/BST) (excluding
                      Bank Holidays)
                    </li>
                    <li data-id="element-576" data-mp="2ezgf3t13pa5f">Saturdays: 9:00 AM to 1:00 PM (GMT/BST)</li>
                    <li data-id="element-577" data-mp="17l3l9h5xjehk">Sundays: Closed</li>
                  </ul>
                  <p className="text-slate mt-2" data-id="element-578" data-mp="13hp5mrlwl04n">
                    Messages received outside of these hours will be addressed
                    promptly on the next working day.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-579" data-mp="3j75h5r80jybt">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-580" data-mp="3o5gr01yb68u1">
                  <MapPin className="h-6 w-6" data-id="element-581" data-mp="3swp1l1bdk08s" />
                </div>
                <div data-id="element-582" data-mp="3sy05r28qfa0f">
                  <h2 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-583" data-mp="1qe75o0vdxqf">
                    Accessibility and Flexibility
                  </h2>
                  <p className="text-slate-dark" data-id="element-584" data-mp="6o5vk82b31pv">
                    Dr. Syed offers exceptional flexibility to accommodate your
                    needs and those of your clients. He can conduct remote
                    assessments across all regions of the UK. For your
                    convenience, in-person assessments can also be arranged, and
                    Dr. Syed is available for prison visits, care home visits,
                    and court attendance when required.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-slate-dark text-lg mb-6" data-id="element-585" data-mp="3ftw61lyoozr7">
              We look forward to partnering with you to provide the expert
              psychiatric insights your cases require.
            </p>
          </div>
          {/* Email Contact Section (Replacing Form) */}
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8 text-center" data-id="element-586" data-mp="7lxoa4eaup96">
            <h2 className="text-2xl font-serif font-bold text-primary mb-6" data-id="element-587" data-mp="7jkxd1qkd4jz">
              Discuss an Instruction
            </h2>
            <div className="mb-8" data-id="element-588" data-mp="ger8mg8lsetw">
              <p className="text-slate-dark text-lg mb-4" data-id="element-589" data-mp="gdpwe8fupmal">
                To discuss an instruction or request a fee quote, please
                include the type of proceedings, the court or tribunal, the
                questions you need answered, any deadlines and where the person
                to be assessed is located. Not every instruction can be
                accepted; Dr Syed will confirm whether he can help.
              </p>
              <ul className="text-slate-dark mb-3 space-y-1 font-medium" data-id="element-590" data-mp="19xxf6x40hkh1">
                <li data-id="element-591" data-mp="19w4edyg2xugy">{turnaround.urgent}</li>
                <li data-id="element-592" data-mp="v1ptfscygazn">{turnaround.standard}</li>
              </ul>
              <p className="text-slate text-sm mb-6" data-id="element-593" data-mp="v3asnva7si3u">{turnaround.caveat}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-594" data-mp="101ud1r95tlu3">
              <Button variant="primary" size="lg" href={`mailto:${practiceEmail}?subject=${encodeURIComponent('Instruction enquiry')}`} data-id="element-595" data-mp="m7bh9ynq1gkr">
                <span className="inline-flex items-center" data-id="element-596" data-mp="cc9rr1pjachn">
                  <Mail className="h-5 w-5 mr-2" aria-hidden="true" data-id="element-597" data-mp="h8qj04s156yy" />
                  {callsToAction.discussInstruction.label}
                </span>
              </Button>
              <Button variant="secondary" size="lg" href={callsToAction.requestFeeQuote.href} data-id="element-598" data-mp="7b3z13vvip84">
                {callsToAction.requestFeeQuote.label}
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}